
import { translate } from "react-i18next";
import * as React from "react";

import { MemberName, Menu, ClanRole } from "@wg/wows-react-uikit";

import styles from "./MemberSelect.scss";

export type IProps = {
  members: Array<{
    id: number;
    roleName: string;
    name: string;
  }>;
  selected: number;
  onChange: () => void;

  t: (arg0: string) => string;
};

const MemberSelect = (props: IProps) => {
  const t = props.t;

  const items = props.members.map(member => {
    return {
      value: member.id,
      content: <div><ClanRole role={member.roleName} />&nbsp;{member.name}</div>
    };
  });

  let label = null;

  if (props.selected) {
    const member = props.members.find(obj => obj.id === props.selected);

    label = member && <MemberName role={member.roleName} name={member.name} />;
  } else {
    label = <div className={styles.label}>{t('Выберите игрока')}</div>;
  }

  return <div className={styles.container}>
            <Menu items={items} itemSelected={props.selected} onItemChange={props.onChange}>
                {
      label}
            </Menu>
        </div>;
};

export default translate()(MemberSelect);